export const SET_CURRENT_USER = "SET_CURRENT_USER";
export const LOG_OUT = "LOG_OUT";